<div class="org-dashboard-container" #gridContainer>
    <!-- Dashboard Header -->
    <div class="dashboard-header">
        <h3 class="dashboard-title">Organization Dashboard</h3>
        <div class="dashboard-actions">
            <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="Add Widget" class="add-widget-btn">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button
                mat-icon-button
                (click)="toggleEditMode()"
                [matTooltip]="editMode ? 'Done Editing' : 'Edit Layout'"
                [class.active]="editMode"
            >
                <mat-icon>{{ editMode ? 'check_circle' : 'edit' }}</mat-icon>
            </button>
        </div>
    </div>

    <mat-menu #addMenu="matMenu" class="add-widget-menu">
        <button mat-menu-item *ngFor="let wt of addableWidgetTypes" (click)="addWidget(wt.type)">
            <mat-icon>{{ wt.icon }}</mat-icon>
            <span class="widget-menu-label">{{ wt.label }}</span>
            <span class="widget-present-check" [class.visible]="isWidgetOnDashboard(wt.type)">
                <mat-icon>check_circle</mat-icon>
            </span>
        </button>
    </mat-menu>

    <!-- Widget Grid -->
    <div class="org-dashboard-grid" [style.grid-template-columns]="'repeat(' + gridColumns + ', 1fr)'">
        <div
            *ngFor="let widget of widgets; trackBy: trackByWidgetId; let i = index"
            class="widget-wrapper"
            [class.widget-hidden]="!isWidgetVisible(widget.type)"
            [class.edit-mode]="editMode"
            [class.drag-source]="dragIndex === i"
            [class.drop-target]="dropTargetIndex === i"
            [class.is-resizing]="widget.isResizing"
            [style.grid-column]="'span ' + getEffectiveColSpan(widget)"
            [style.grid-row]="'span ' + widget.layout.rowSpan"
        >
            <mat-card class="widget-card" *ngIf="isWidgetVisible(widget.type)">
                <!-- Widget Header -->
                <div class="widget-header">
                    <div class="widget-title-area">
                        <mat-icon class="drag-handle" *ngIf="editMode" (pointerdown)="onDragHandleDown($event, i)"
                            >drag_indicator</mat-icon
                        >
                        <span class="widget-title">{{ widget.title }}</span>
                    </div>
                    <div class="widget-actions" *ngIf="editMode">
                        <!-- Resize badge showing current size -->
                        <span class="resize-badge" *ngIf="widget.isResizing">
                            {{ getResizeBadge(widget) }}
                        </span>
                        <button
                            mat-icon-button
                            matTooltip="Remove Widget"
                            class="widget-action-btn"
                            (click)="removeWidget(widget)"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <!-- Color settings for overview widget (always visible) -->
                    <button
                        *ngIf="widget.type === 'org-overview' && !editMode && isAdmin"
                        mat-icon-button
                        class="widget-color-btn"
                        matTooltip="Customize entity colors"
                        (click)="onOpenColorPicker()"
                    >
                        <mat-icon>palette</mat-icon>
                    </button>
                </div>

                <!-- Widget Content -->
                <div class="widget-content">
                    <ng-container [ngSwitch]="widget.type">
                        <shared-org-overview-widget
                            *ngSwitchCase="'org-overview'"
                            [data]="scoped?.overview!"
                            (tileClicked)="tileClicked.emit($event)"
                        >
                        </shared-org-overview-widget>

                        <shared-org-hierarchy-widget *ngSwitchCase="'org-hierarchy'" [data]="widgetData">
                        </shared-org-hierarchy-widget>

                        <shared-recent-activity-widget *ngSwitchCase="'recent-activity'" [data]="widgetData">
                        </shared-recent-activity-widget>

                        <shared-security-coverage-widget *ngSwitchCase="'security-coverage'" [data]="widgetData">
                        </shared-security-coverage-widget>

                        <shared-policy-status-widget *ngSwitchCase="'policy-status'" [data]="scoped?.policyStatus!">
                        </shared-policy-status-widget>

                        <shared-user-directory-widget *ngSwitchCase="'user-directory'" [data]="widgetData">
                        </shared-user-directory-widget>

                        <shared-policy-acknowledgment-widget
                            *ngSwitchCase="'policy-acknowledgment'"
                            [data]="scoped?.acknowledgment!"
                        >
                        </shared-policy-acknowledgment-widget>

                        <shared-feature-map-widget *ngSwitchCase="'feature-map'" [data]="scoped?.featureMap!">
                        </shared-feature-map-widget>

                        <div *ngSwitchDefault class="widget-unknown">
                            <mat-icon>help_outline</mat-icon>
                            <span>Unknown widget type: {{ widget.type }}</span>
                        </div>
                    </ng-container>
                </div>

                <!-- Resize Handle (bottom-right corner) -->
                <div class="resize-handle" *ngIf="editMode" (pointerdown)="onResizeStart(widget, $event)">
                    <mat-icon class="resize-icon">drag_handle</mat-icon>
                </div>
            </mat-card>
        </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="widgets.length === 0" class="dashboard-empty">
        <mat-icon class="empty-icon">dashboard_customize</mat-icon>
        <h4>No widgets yet</h4>
        <p>Click the <mat-icon inline>add_circle_outline</mat-icon> button above to add widgets to your dashboard.</p>
    </div>
</div>
